import React from 'react';

const LockOrange = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    style: { ...style, overflow: "visible" },
    className,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.0015 23.1338C17.2018 23.1338 18.1748 22.1607 18.1748 20.9604C18.1748 19.7601 17.2018 18.7871 16.0015 18.7871C14.8012 18.7871 13.8281 19.7601 13.8281 20.9604C13.8281 22.1607 14.8012 23.1338 16.0015 23.1338Z",
      fill: "#FF7400"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M24.3746 12.707V11.0403C24.3746 7.44033 23.508 2.66699 16.0013 2.66699C8.49464 2.66699 7.62797 7.44033 7.62797 11.0403V12.707C3.89464 13.1737 2.66797 15.067 2.66797 19.7203V22.2003C2.66797 27.667 4.33464 29.3337 9.8013 29.3337H22.2013C27.668 29.3337 29.3346 27.667 29.3346 22.2003V19.7203C29.3346 15.067 28.108 13.1737 24.3746 12.707ZM16.0013 24.987C13.7746 24.987 11.9746 23.1737 11.9746 20.9603C11.9746 18.7337 13.788 16.9337 16.0013 16.9337C18.2146 16.9337 20.028 18.747 20.028 20.9603C20.028 23.187 18.228 24.987 16.0013 24.987ZM9.8013 12.587C9.69464 12.587 9.6013 12.587 9.49464 12.587V11.0403C9.49464 7.13366 10.6013 4.53366 16.0013 4.53366C21.4013 4.53366 22.508 7.13366 22.508 11.0403V12.6003C22.4013 12.6003 22.308 12.6003 22.2013 12.6003H9.8013V12.587Z",
      fill: "#FF7400"
    }
  )
);
LockOrange.displayName = "Icons.LockOrange";

export { LockOrange };
//# sourceMappingURL=LockOrange.js.map
